import { Link } from 'gatsby'
// import PropTypes from 'prop-types'
import React from 'react'

import styles from './Works.module.scss'
import Title from '../images/svg/head_works.svg'
import Button from './Button'
import Sunny from '../images/svg/icon_sunny.svg'
import ArrowRight from '../images/svg/icon_arrow-right.svg'

const items = [
    {
        date: '2019.09.10',
        title: 'ANAグループ体操（クライアント: 全日空空輸様）',
        link: 'https://www.youtube.com/watch?v=WqhZxb0Hurg',
        link_type: 'link',
        thumbnail_url: 'http://img.youtube.com/vi/WqhZxb0Hurg/maxresdefault.jpg',
        tags: ['Web Movie', 'YouTube']
    },
    {
        date: '2019.09.10',
        title: 'DANCE DANCE ASIA（クライアント: PARCO様）',
        link: 'https://www.youtube.com/watch?v=YQtla9dH4I8',
        link_type: 'link',
        thumbnail_url: 'http://img.youtube.com/vi/YQtla9dH4I8/maxresdefault.jpg',
        tags: ['Web Movie', 'YouTube']
    },
    {
        date: '2019.09.10',
        title: 'KABA.ちゃんCM（クライアント: トリピュア・ジャパン様）',
        link: 'https://www.youtube.com/watch?v=ecj5dLnSm5A',
        link_type: 'link',
        thumbnail_url: 'http://img.youtube.com/vi/ecj5dLnSm5A/maxresdefault.jpg',
        tags: ['Web Movie', 'YouTube']
    },
    {
        date: '2019.09.10',
        title: 'KSP Project（クライアント: 大同生命株式会社様）',
        link: 'https://www.youtube.com/watch?v=s0vueqS5SBg',
        link_type: 'link',
        thumbnail_url: 'http://img.youtube.com/vi/s0vueqS5SBg/maxresdefault.jpg',
        tags: ['Web Movie', 'YouTube']
    },
    {
        date: '2019.09.10',
        title: 'ルネサンス館内映像（クライアント: 株式会社ルネサンス様）',
        link: 'https://www.youtube.com/watch?v=E3EHcwRVLts',
        link_type: 'link',
        thumbnail_url: 'http://img.youtube.com/vi/E3EHcwRVLts/maxresdefault.jpg',
        tags: ['Web Movie', 'YouTube']
    },
    {
        date: '2019.09.10',
        title: 'Quolive nterview（クライアント: RIZAP Quolive様）',
        link: 'https://www.youtube.com/watch?v=JJb5p6iE4UI',
        link_type: 'link',
        thumbnail_url: 'http://img.youtube.com/vi/JJb5p6iE4UI/maxresdefault.jpg',
        tags: ['Web Movie', 'YouTube']
    },
    {
        date: '2019.09.10',
        title: 'アクトンルーム',
        link: 'https://www.youtube.com/watch?v=8OmeFeoBj8c',
        link_type: 'link',
        thumbnail_url: 'http://img.youtube.com/vi/8OmeFeoBj8c/maxresdefault.jpg',
        tags: ['Web Movie', 'YouTube']
    },
    {
        date: '2019.09.10',
        title: 'True Colors Festival 連携プログラム「Babywearing Dance」 in 渋谷音楽祭',
        link: 'https://www.youtube.com/watch?v=zPNlL-3YGlM',
        link_type: 'link',
        thumbnail_url: 'http://img.youtube.com/vi/zPNlL-3YGlM/maxresdefault.jpg',
        tags: ['Web Movie', 'YouTube']
    }
];

const Item = ({ item }) => (
    <div className={styles.item}>
        <div className={styles.itemDate}>
            {item.data}
        </div>
        <a 
            className={styles.itemThumb}
            href={item.link}
            target="_blank"
        >
            <div className={styles.itemThumbInner}>
                <img src={item.thumbnail_url} alt={item.title} />
            </div>
            <div className={styles.itemThumbHover}>
                <div className={styles.itemThumbHoverIcon}>
                    <Sunny />
                    <ArrowRight />
                </div>
            </div>
            <div className={styles.itemTags}>
                {item.tags.map(tag => <div className={styles.itemTag}>{tag}</div>)}
            </div>
        </a>
        <a 
            className={styles.itemHead}
            href={item.link}
            target="_blank"
        >
            {item.title}
        </a>
    </div>    
);


const Works = () => (
    <section name="works" className={styles.wrapper}>
        <div className={styles.container}>
            <h2 className="sr-only">制作実績</h2>
            <div className={styles.head}>
                <Title />
            </div>
            <div className={styles.items}>
                {items.map(item => <Item item={item} />)}
            </div>
        </div>
    </section>
)

export default Works;
